
import * as xss from "xss";
import * as showdown from "showdown";
import { formatString } from "./objectUtils";


const markdownOptions: showdown.ShowdownOptions = {
  noHeaderId: true,
  strikethrough: true,
  tables: true,
  emoji: true,
  parseImgDimensions: true
};


const stylingWhitelist = ["style", "class"];
const xssOptions: xss.IFilterXSSOptions = {
  whiteList: {
    ...xss.getDefaultWhiteList(),
    span: stylingWhitelist,
    div: stylingWhitelist
  }
};


export function markdownToHtml(content: string | string[], mergeFields?: object) {
  if (typeof content === 'string') {
    content = [content];
  }

  const markdown = content.join('\n');
  const mergedContent = mergeFields ? formatString(markdown, mergeFields) : markdown;

  const converter = new showdown.Converter(markdownOptions);
  const unsafeHtml = converter.makeHtml(mergedContent);
  const saferHtml = xss.filterXSS(unsafeHtml, xssOptions);
  return saferHtml;
}

